<template>
    <div class="csw">
        <!-- cabeçalho: dados da liberação de inscrição (somente leitura, vindos do ERP) -->
        <section class="ec-card">
            <header class="ec-card__cabecalho">
                <span class="ec-card__icone"><i class="fa-solid fa-globe"></i></span>
                <div class="ec-card__textos">
                    <h2 class="ec-card__titulo">{{ curso.descricaocurso || processo_seletivo.descricaocurso || 'Inscrição web' }}</h2>
                    <p class="ec-card__subtitulo">Liberação de inscrição web · dados importados do ERP</p>
                </div>
                <span class="ec-card__extra csw-extra">
                    <span class="ec-card__etiqueta" v-if="curso.descricaomodalidade">{{ curso.descricaomodalidade }}</span>
                    <span v-if="curso.ativo!==undefined && curso.ativo!==null" class="ec-status" :class="cursoAtivo ? 'ec-status--sucesso' : 'ec-status--neutro'">{{ cursoAtivo ? 'Curso ativo' : 'Curso inativo' }}</span>
                </span>
            </header>
            <div class="ec-card__corpo">
                <dl class="csw-dados">
                    <div>
                        <dt>ID do processo no ERP</dt>
                        <dd>{{ processo_seletivo.idliberacaoinscricaocurso || '—' }}</dd>
                    </div>
                    <div>
                        <dt>Ano / semestre</dt>
                        <dd>{{ processo_seletivo.ano || '—' }}<template v-if="processo_seletivo.semestre"> / {{ processo_seletivo.semestre }}º</template></dd>
                    </div>
                    <div>
                        <dt>Curso no ERP</dt>
                        <dd>
                            {{ curso.codigocurso || '—' }}
                            <small v-if="curso.codigoidentificacao" class="text-muted">· Ident. {{ curso.codigoidentificacao }}</small>
                        </dd>
                    </div>
                    <div>
                        <dt>Nível de ensino</dt>
                        <dd>{{ processo_seletivo.descricaonivelensino || curso.descricaonivelensino || '—' }}</dd>
                    </div>
                    <div>
                        <dt>Estrutura acadêmica</dt>
                        <dd>{{ processo_seletivo.descricaoestruturaacademica || '—' }}</dd>
                    </div>
                    <div>
                        <dt>Origem de matrícula</dt>
                        <dd>{{ processo_seletivo.descricaoorigemmatricula || '—' }}</dd>
                    </div>
                    <div>
                        <dt>Público</dt>
                        <dd>{{ processo_seletivo.publico || '—' }}</dd>
                    </div>
                </dl>

                <ul class="csw-totais">
                    <li><b>{{ turmas.length }}</b> turma(s)</li>
                    <li><span class="ec-status ec-status--sucesso">{{ resumo.noCrm }} no CRM</span></li>
                    <li v-if="resumo.pendentes>0"><span class="ec-status ec-status--aguardando">{{ resumo.pendentes }} não exportada(s)</span></li>
                    <li v-if="resumo.expirar>0"><span class="ec-status ec-status--erro">{{ resumo.expirar }} para expirar no CRM</span></li>
                </ul>

                <div class="ec-form-acoes">
                    <a :href="'/'+urlSistema" class="btn btn-outline-primary"><b-icon icon="arrow-left"></b-icon> Voltar</a>
                    <button v-if="resumo.pendentes>0" type="button" class="btn btn-primary" :disabled="!!lote || exportando>0" @click="confirmarExportarPendentes()">
                        <b-icon icon="cloud-upload"></b-icon>
                        {{ lote ? 'Exportando ' + lote.feitas + '/' + lote.total + '...' : 'Exportar não exportadas (' + resumo.pendentes + ')' }}
                    </button>
                </div>
            </div>
        </section>

        <!-- turmas (ofertas) vinculadas à inscrição -->
        <section class="ec-card">
            <header class="ec-card__cabecalho">
                <span class="ec-card__icone"><i class="fa-solid fa-users"></i></span>
                <div class="ec-card__textos">
                    <h2 class="ec-card__titulo">Turmas vinculadas</h2>
                    <p class="ec-card__subtitulo">Situação de cada oferta no ERP e no CRM, com a ação disponível.</p>
                </div>
                <span class="ec-card__extra"><span class="ec-card__etiqueta">{{ turmas.length }}</span></span>
            </header>
            <div class="ec-card__corpo ec-card__corpo--flush">
                <div v-if="turmas.length>3" class="csw-filtros" role="group" aria-label="Filtrar turmas">
                    <button v-for="opcao in filtros" :key="opcao.valor" type="button" class="btn btn-sm"
                        :class="filtro==opcao.valor ? 'btn-primary' : 'btn-outline-primary'" @click="filtro=opcao.valor">
                        {{ opcao.texto }} <span class="csw-filtros__qtd">{{ opcao.qtd }}</span>
                    </button>
                </div>

                <p v-if="turmas.length==0" class="csw-vazio">
                    Nenhuma turma com oferta vinculada a esta inscrição.
                </p>
                <p v-else-if="turmasVisiveis.length==0" class="csw-vazio">
                    Nenhuma turma nesta situação.
                </p>
                <ul v-else class="csw-lista">
                    <li v-for="turma in turmasVisiveis" :key="turma.id" class="csw-turma">
                        <div class="csw-turma__linha">
                            <div class="csw-turma__info">
                                <span class="csw-turma__nome">{{ turma.descricaoofertainscricao || turma.descricaocompleta || turma.codigooferta }}</span>
                                <span class="csw-turma__meta">
                                    <span v-if="turma.codigooferta">Oferta {{ turma.codigooferta }}</span>
                                    <span v-if="turma.descricaociclo">{{ turma.descricaociclo }}</span>
                                    <span><b-icon icon="calendar3"></b-icon> Inscrições: {{ formatarData(turma.datainicioinscricao) }} a {{ formatarData(turma.dataterminoinscricao) }}</span>
                                    <span v-if="vagas(turma)">{{ vagas(turma) }}</span>
                                    <span v-if="turma.modality && turma.modality.modalidade">{{ turma.modality.modalidade }}</span>
                                </span>
                            </div>
                            <div class="csw-turma__extra">
                                <span class="ec-status" :class="'ec-status--'+situacao(turma).variante" :title="situacao(turma).dica">{{ situacao(turma).texto }}</span>
                                <button v-if="planoPagamento(turma)" type="button" class="btn btn-link btn-sm p-0 csw-valor" title="Ver plano de pagamento" @click="verPlanoPagamento(turma)">
                                    {{ valorOferta(turma) }} <b-icon icon="info-circle"></b-icon>
                                </button>
                                <span v-else class="csw-valor" :class="{ 'csw-valor--isento': valorOferta(turma)=='Isento' }">{{ valorOferta(turma) }}</span>
                                <a class="btn btn-outline-primary btn-sm" :href="'/Access/Unity/Unitie/'+unidade.id+'/captacao/'+turma.id" title="Inscrições recebidas do CRM para esta turma">
                                    <i class="fa-solid fa-satellite-dish"></i> WebHooks
                                </a>
                                <button v-if="acao(turma)" type="button" class="btn btn-sm" :class="acao(turma).classe"
                                    :disabled="turma._estado=='exportando' || !!lote || !acao(turma).habilitada"
                                    :title="acao(turma).dica"
                                    @click="executarAcao(turma)">
                                    <b-spinner v-if="turma._estado=='exportando'" small></b-spinner>
                                    <b-icon v-else :icon="acao(turma).icone"></b-icon>
                                    {{ turma._estado=='exportando' ? 'Enviando...' : acao(turma).texto }}
                                </button>
                            </div>
                        </div>
                        <div v-if="turma._estado=='sucesso' || turma._estado=='erro'" class="csw-retorno" :class="'csw-retorno--'+turma._estado" role="status">
                            <template v-if="turma._estado=='sucesso'">
                                <b-icon icon="check-circle-fill"></b-icon> {{ turma._mensagem }} às {{ turma._horario }}
                            </template>
                            <template v-else>
                                <b-icon icon="x-circle-fill"></b-icon> Falhou: {{ turma._mensagem }}
                            </template>
                        </div>
                    </li>
                </ul>
            </div>
        </section>

        <b-modal id="cswPlanoPagamento" title="Plano de pagamento" ok-only ok-title="Fechar" ok-variant="outline-primary" centered size="lg" @hidden="plano_pagamento_visualizar=null">
            <template v-if="plano_pagamento_visualizar">
                <dl class="csw-dados">
                    <div>
                        <dt>Descrição</dt>
                        <dd>{{ plano_pagamento_visualizar.descricaoPlanoPagamento || '—' }}</dd>
                    </div>
                    <div>
                        <dt>Parcelas</dt>
                        <dd>{{ (plano_pagamento_visualizar.parcelas || []).length }}</dd>
                    </div>
                    <div>
                        <dt>Total</dt>
                        <dd>{{ $root.numberToReal(totalPlano(plano_pagamento_visualizar)) }}</dd>
                    </div>
                </dl>
                <div class="ec-listagem">
                    <div class="table-responsive ec-listagem__rolagem">
                        <table class="table table-sm table-hover ec-tabela mb-0">
                            <thead class="ec-thead">
                                <tr>
                                    <th class="text-center">Parcela</th>
                                    <th class="text-left">Tipo de parcela</th>
                                    <th class="text-left">Evento</th>
                                    <th class="text-right">Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="(plano_pagamento_visualizar.parcelas || []).length==0">
                                    <td colspan="4" class="ec-tabela__estado">
                                        <b-icon icon="inbox" font-scale="2"></b-icon>
                                        <p>Este plano não tem parcelas cadastradas.</p>
                                    </td>
                                </tr>
                                <tr v-for="parcela,i in plano_pagamento_visualizar.parcelas" :key="i">
                                    <td class="text-center" data-label="Parcela">Parcela {{ parcela.numeroParcela }}</td>
                                    <td class="text-left" data-label="Tipo de parcela">{{ parcela.descricaoTipoParcela || '—' }}</td>
                                    <td class="text-left" data-label="Evento">
                                        <template v-if="evento(parcela)">{{ evento(parcela).descricaoEvento }}</template>
                                        <span v-else class="ec-tabela__vazio">—</span>
                                    </td>
                                    <td class="text-right" data-label="Valor">
                                        <template v-if="evento(parcela)">{{ $root.numberToReal(parseFloat(evento(parcela).valor)) }}</template>
                                        <span v-else class="ec-tabela__vazio">—</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default{
    props:{
        unidade:{
            type:Object,
            required:true
        },
        urlSistema:{
            type:String,
            required:true
        },
        processo:{
            type:Object,
            required:false
        },
        // mantidos por compatibilidade com as views (a tela é somente de visualização)
        visualizar:Boolean,
        edit:Boolean,
        nomeFormulario:String,
        metodoFormulario:String,
        linkAction:String,
        usuarioAutenticado:Object,
        usuarios:[String, Array],
    },
    data(){
        return{
            processo_seletivo:{},
            turmas:[],
            filtro:'todas',
            exportando:0,
            lote:null,
            plano_pagamento_visualizar:null,
        }
    },
    created(){
        this.processo_seletivo = Object.assign({}, this.processo || {})
        // estado da última ação de cada turma nesta sessão (_estado, _mensagem, _horario)
        this.turmas = (this.processo_seletivo.turmas_inscricao || []).map(turma => Object.assign({}, turma, {
            _estado:null,
            _mensagem:null,
            _horario:null,
        }))
    },
    computed:{
        curso(){
            return this.processo_seletivo.curso_inscricao || {}
        },
        cursoAtivo(){
            const ativo = this.curso.ativo
            return ativo === true || ativo == 1 || String(ativo).toUpperCase() == 'S' || String(ativo).toLowerCase() == 'ativo'
        },
        resumo(){
            return {
                noCrm: this.turmas.filter(t => this.categoria(t)=='crm').length,
                pendentes: this.turmas.filter(t => this.categoria(t)=='pendente').length,
                expirar: this.turmas.filter(t => this.categoria(t)=='expirar').length,
            }
        },
        filtros(){
            const qtd = c => this.turmas.filter(t => this.categoria(t)==c).length
            return [
                { valor:'todas', texto:'Todas', qtd:this.turmas.length },
                { valor:'crm', texto:'No CRM', qtd:qtd('crm') },
                { valor:'pendente', texto:'Não exportadas', qtd:qtd('pendente') },
                { valor:'expirar', texto:'Para expirar', qtd:qtd('expirar') },
                { valor:'inativa', texto:'Encerradas / fora do ERP', qtd:qtd('inativa') },
            ].filter(f => f.valor=='todas' || f.qtd>0)
        },
        turmasVisiveis(){
            if(this.filtro=='todas') return this.turmas
            return this.turmas.filter(t => this.categoria(t)==this.filtro)
        },
    },
    methods:{
        // usa só a parte aaaa-mm-dd como data local: as datas vêm do banco ("aaaa-mm-dd hh:mm:ss")
        // ou do Carbon em ISO com fuso, e convertê-las com fuso pode voltar um dia
        paraData(valor){
            if(!valor) return null
            if(valor instanceof Date) return valor
            const local = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(valor))
            const data = local ? new Date(local[1], local[2]-1, local[3]) : new Date(valor)
            return isNaN(data.getTime()) || data.getFullYear() < 1971 ? null : data
        },
        formatarData(valor){
            const data = this.paraData(valor)
            return data ? data.toLocaleDateString('pt-BR') : '—'
        },
        // aaaa-mm-dd esperado pela API de exportação
        dataIso(valor){
            const data = this.paraData(valor)
            if(!data) return null
            return data.getFullYear() + '-' + String(data.getMonth()+1).padStart(2,'0') + '-' + String(data.getDate()).padStart(2,'0')
        },
        vagas(turma){
            const minimo = turma.tamanhoturmaminimo, maximo = turma.tamanhoturmaximo
            const temMin = minimo !== null && minimo !== undefined && minimo !== '' && minimo > 0
            const temMax = maximo !== null && maximo !== undefined && maximo !== '' && maximo > 0
            if(temMin && temMax) return 'Vagas: ' + minimo + ' a ' + maximo
            if(temMax) return 'Até ' + maximo + ' vagas'
            if(temMin) return 'Mínimo ' + minimo + ' alunos'
            return null
        },
        valorOferta(turma){
            const valor = parseFloat(turma.valoroferta)
            if(isNaN(valor)) return '—'
            return valor == 0 ? 'Isento' : this.$root.numberToReal(valor)
        },
        planoPagamento(turma){
            return Array.isArray(turma.planosPagamento) && turma.planosPagamento.length > 0 ? turma.planosPagamento[0] : null
        },
        evento(parcela){
            return (parcela.eventos || []).length > 0 ? parcela.eventos[0] : null
        },
        totalPlano(plano){
            return (plano.parcelas || []).reduce((soma, parcela) => {
                const evento = this.evento(parcela)
                const valor = evento ? parseFloat(evento.valor) : NaN
                return soma + (isNaN(valor) ? 0 : valor)
            }, 0)
        },
        // crm: ativa no ERP e no CRM · pendente: ativa no ERP, fora do CRM
        // expirar: encerrada no ERP, ainda no CRM · inativa: encerrada ou não encontrada no ERP, fora do CRM
        categoria(turma){
            if(turma.expirado === true) return turma.existe_crm ? 'expirar' : 'inativa'
            if(turma.existe_erp) return turma.existe_crm ? 'crm' : 'pendente'
            return 'inativa'
        },
        situacao(turma){
            switch(this.categoria(turma)){
                case 'crm': return { texto:'No CRM', variante:'sucesso', dica:'Oferta ativa no ERP e publicada no CRM' }
                case 'pendente': return { texto:'Não exportada', variante:'aguardando', dica:'Oferta ativa no ERP, mas ainda não existe no CRM' }
                case 'expirar': return { texto:'Encerrada · ainda no CRM', variante:'erro', dica:'O período de inscrição terminou no ERP, mas a oferta continua no CRM' }
            }
            if(turma.expirado === true) return { texto:'Encerrada', variante:'neutro', dica:'Período de inscrição encerrado no ERP' }
            return { texto:'Fora do ERP', variante:'neutro', dica:'A turma não está mais liberada para inscrição no ERP' }
        },
        podeExportar(turma){
            return !!(turma.modality && turma.turma_vinculo_inscricao)
        },
        acao(turma){
            const categoria = this.categoria(turma)
            if(categoria=='inativa') return null
            const habilitada = this.podeExportar(turma)
            const semDados = !turma.modality ? 'Turma sem modalidade: configure no ERP para poder enviar ao CRM' : 'Vínculo com a liberação do ERP não encontrado'
            if(categoria=='expirar') return { texto:'Expirar no CRM', icone:'clock-history', classe:'btn-outline-danger', habilitada, dica: habilitada ? 'Envia ao CRM a data de término do ERP, encerrando as inscrições' : semDados }
            if(categoria=='crm') return { texto:'Atualizar CRM', icone:'arrow-repeat', classe:'btn-outline-primary', habilitada, dica: habilitada ? 'Reenvia os dados atuais do ERP para a oferta no CRM' : semDados }
            return { texto:'Exportar CRM', icone:'cloud-upload', classe:'btn-primary', habilitada, dica: habilitada ? 'Cria a oferta no CRM' : semDados }
        },
        avisar(mensagem,variante,titulo){
            this.$bvToast.toast(mensagem, {
                title: titulo,
                variant: variante,
                solid: true,
                toaster: 'b-toaster-top-right',
                autoHideDelay: variante=='danger' ? 8000 : 4000,
            })
        },
        mensagemErro(erros){
            if(!erros) return 'Erro não informado pelo CRM.'
            if(typeof erros === 'string') return erros
            // o CRM devolve objeto/array de mensagens; achata em uma linha legível
            const lista = []
            const coletar = v => {
                if(v === null || v === undefined) return
                if(typeof v === 'object') Object.values(v).forEach(coletar)
                else lista.push(String(v))
            }
            coletar(erros)
            return lista.length ? lista.join(' · ') : JSON.stringify(erros)
        },
        // devolve null em caso de sucesso ou a mensagem de erro
        lerRetornoExportacao(dados){
            if(Array.isArray(dados) && dados.length>0 && dados[0].error){
                let erro = dados[0].message
                try{
                    const json = typeof erro === 'string' ? JSON.parse(erro) : erro
                    erro = json && json.errors ? json.errors : json
                }catch(e){ /* mensagem em texto */ }
                return this.mensagemErro(erro)
            }
            if(dados && dados.resposta){
                let resposta = dados.resposta
                try{
                    resposta = typeof resposta === 'string' ? JSON.parse(resposta) : resposta
                }catch(e){
                    return null
                }
                if(resposta && resposta.success === false) return this.mensagemErro(resposta.errors)
            }
            return null
        },
        verPlanoPagamento(turma){
            this.plano_pagamento_visualizar = this.planoPagamento(turma)
            this.$bvModal.show('cswPlanoPagamento')
        },
        montarOferta(turma){
            const curso = this.curso
            const local = this.unidade.companies.codigoempresa + '-' + this.unidade.codigounidade
            return {
                idLiberacaoInscricaoCurso: this.processo_seletivo.idliberacaoinscricaocurso,
                idLiberacaoInscricaoTurma: turma.turma_vinculo_inscricao.idliberacaoinscricaoturma,
                ano: turma.anoinicio,
                semestre: this.processo_seletivo.semestre,
                idNivelEnsino: curso.codigonivelensino,
                descricaoNivelEnsino: curso.descricaonivelensino,
                idEstruturaAcademica: turma.modality.idmodalidadeexportacao,
                descricaoEstruturaAcademica: turma.modality.modalidade,
                idOrigemMatricula: this.processo_seletivo.idorigemmatricula,
                descricaoOrigemMatricula: this.processo_seletivo.descricaoorigemmatricula,
                publico: this.processo_seletivo.publico,
                codCurso: curso.codigocurso,
                codOferta: turma.codigooferta,
                codigo: turma.codigooferta,
                nomeCurso: curso.descricaocurso,
                descricaoCurso: curso.descricaocurso,
                nome: turma.descricaoofertainscricao,
                complemento: turma.descricaocomplemento,
                codUnidade: local,
                inicioInscricao: this.dataIso(turma.datainicioinscricao),
                terminoInscricao: this.dataIso(turma.dataterminoinscricao),
                inicioMatricula: turma.datainicio,
                terminoMatricula: turma.datatermino,
                inicioCurso: turma.datainicio,
                terminoCurso: turma.datatermino,
                codNivelEnsino: curso.codigonivelensino,
                modalidade: turma.modality.idmodalidadeexportacao,
                codLocalOferta: local,
                origem: this.unidade.origem,
                valor: turma.valoroferta,
                plano_pagamento: this.planoPagamento(turma),
                vagasMinimo: turma.tamanhoturmaminimo,
                vagasMaximo: turma.tamanhoturmaximo,
            }
        },
        executarAcao(turma){
            if(this.categoria(turma)!='expirar') return this.enviarTurma(turma)
            this.$bvModal.msgBoxConfirm('Encerrar as inscrições de ' + (turma.descricaoofertainscricao || turma.codigooferta) + ' no CRM? A oferta passa a ter a data de término do ERP (' + this.formatarData(turma.dataterminoinscricao) + ').', {
                title: 'Expirar no CRM',
                okTitle: 'Expirar',
                cancelTitle: 'Cancelar',
                okVariant: 'danger',
                cancelVariant: 'outline-primary',
                centered: true,
            }).then(confirmou => {
                if(confirmou) this.enviarTurma(turma)
            })
        },
        // envia a turma ao CRM (exportar, atualizar ou expirar: a API é a mesma)
        enviarTurma(turma, silencioso){
            if(!this.podeExportar(turma)) return Promise.resolve(false)
            const categoria = this.categoria(turma)
            const oferta = this.montarOferta(turma)
            turma._estado = 'exportando'
            turma._mensagem = null
            this.exportando++

            const formData = new FormData()
            formData.append('dadosOferta', JSON.stringify(oferta))

            return axios.post('/api/v1/Crm/cadastroOferta/' + this.unidade.id, formData)
                .then(response => {
                    const erro = this.lerRetornoExportacao(response.data)
                    if(erro){
                        turma._estado = 'erro'
                        turma._mensagem = erro
                        if(!silencioso) this.avisar('O CRM recusou a oferta ' + oferta.nome + '.', 'danger', 'Erro no envio')
                        return false
                    }
                    const feito = categoria=='expirar' ? 'Inscrições encerradas no CRM' : (categoria=='crm' ? 'Oferta atualizada no CRM' : 'Oferta exportada para o CRM')
                    turma._estado = 'sucesso'
                    turma._mensagem = feito
                    turma._horario = new Date().toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit' })
                    turma.existe_crm = true
                    if(!silencioso) this.avisar(feito + ': ' + oferta.nome + '.', 'success', 'Envio concluído')
                    return true
                })
                .catch(erro => {
                    console.log(erro)
                    const detalhe = erro.response && erro.response.data ? erro.response.data.message : null
                    turma._estado = 'erro'
                    turma._mensagem = detalhe ? String(detalhe) : 'Erro de comunicação. Verifique a conexão e tente novamente.'
                    if(!silencioso) this.avisar('Erro ao enviar a oferta ao CRM. Tente novamente.', 'danger', 'Erro no envio')
                    return false
                })
                .finally(() => {
                    this.exportando--
                })
        },
        confirmarExportarPendentes(){
            const pendentes = this.turmas.filter(t => this.categoria(t)=='pendente' && this.podeExportar(t))
            if(pendentes.length==0){
                this.avisar('As turmas não exportadas estão sem modalidade ou sem vínculo com o ERP.', 'warning', 'Nada para exportar')
                return
            }
            this.$bvModal.msgBoxConfirm('Exportar ' + pendentes.length + ' turma(s) para o CRM?', {
                title: 'Exportar para o CRM',
                okTitle: 'Exportar',
                cancelTitle: 'Cancelar',
                okVariant: 'primary',
                cancelVariant: 'outline-primary',
                centered: true,
            }).then(confirmou => {
                if(confirmou) this.exportarLote(pendentes)
            })
        },
        // uma turma por vez, para não sobrecarregar o CRM
        async exportarLote(turmas){
            this.lote = { feitas:0, total:turmas.length }
            let sucessos = 0
            for(const turma of turmas){
                if(await this.enviarTurma(turma, true)) sucessos++
                this.lote.feitas++
            }
            this.lote = null
            if(sucessos == turmas.length){
                this.avisar(sucessos + ' turma(s) exportada(s) para o CRM.', 'success', 'Exportação concluída')
            }else{
                this.avisar((turmas.length-sucessos) + ' de ' + turmas.length + ' turma(s) não foram exportadas. Veja o motivo em cada turma.', 'warning', 'Exportação com pendências')
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';

.csw { text-align: left; }

.csw-extra {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .4rem;
}

.csw-dados {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
    gap: 1rem 1.5rem;
    margin: 0 0 1rem;

    dt {
        margin-bottom: .15rem;
        font-size: .72rem;
        font-weight: 600;
        letter-spacing: .03em;
        text-transform: uppercase;
        color: $ec-texto-suave;
    }

    dd {
        margin: 0;
        font-weight: 600;
        color: $ec-texto;
    }
}

.csw-totais {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: .5rem 1rem;
    margin: 0;
    padding: .75rem 0 0;
    list-style: none;
    border-top: 1px solid $ec-borda;
    font-size: .85rem;
    color: $ec-texto-suave;

    b { color: $ec-texto; }
}

.csw-filtros {
    display: flex;
    flex-wrap: wrap;
    gap: .4rem;
    padding: .75rem 1.25rem;
    border-bottom: 1px solid $ec-borda;
}

.csw-filtros__qtd {
    display: inline-block;
    min-width: 1.3rem;
    margin-left: .2rem;
    padding: 0 .35rem;
    border-radius: 999px;
    font-size: .72rem;
    background: rgba($ec-petroleo, .12);
}

.btn-primary .csw-filtros__qtd { background: rgba(#fff, .25); }

.csw-vazio {
    margin: 0;
    padding: 1.25rem;
    color: $ec-texto-suave;
}

.csw-lista {
    margin: 0;
    padding: 0;
    list-style: none;
}

.csw-turma {
    border-top: 1px solid $ec-borda;

    &:first-child { border-top: 0; }
}

.csw-turma__linha {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .5rem 1rem;
    padding: .8rem 1.25rem;
}

.csw-turma__info {
    flex: 1 1 320px;
    min-width: 0;
}

.csw-turma__nome {
    display: block;
    font-weight: 700;
    color: $ec-petroleo-escuro;
    overflow-wrap: anywhere;
}

.csw-turma__meta {
    display: flex;
    flex-wrap: wrap;
    gap: .1rem 1rem;
    font-size: .8rem;
    color: $ec-texto-suave;
}

.csw-turma__extra {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .5rem .75rem;
}

.csw-valor {
    font-weight: 700;
    color: $ec-texto;
    white-space: nowrap;

    &--isento { color: $green; }
}

.csw-retorno {
    display: flex;
    align-items: flex-start;
    gap: .4rem;
    margin: 0 1.25rem .8rem;
    padding: .4rem .7rem;
    border-radius: .35rem;
    font-size: .8rem;
    overflow-wrap: anywhere;

    svg { flex: 0 0 auto; margin-top: .15rem; }

    &--sucesso { color: darken($green, 12%); background: rgba($green, .08); }
    &--erro { color: darken($red, 8%); background: rgba($red, .08); }
}

@media (max-width: 575.98px) {
    .csw-turma__linha,
    .csw-filtros { padding-left: 1rem; padding-right: 1rem; }
    .csw-retorno { margin-left: 1rem; margin-right: 1rem; }
}
</style>
